type IStyleGuideColorKey =
  | "beige"
  | "black"
  | "brown"
  | "darkBlack"
  | "darkGold"
  | "darkGrey"
  | "darkRedDesktop"
  | "gold"
  | "goldDesktop"
  | "grey"
  | "infoBackground"
  | "infoBorder"
  | "infoText"
  | "lightBrown"
  | "lightGrey"
  | "lightRed"
  | "mediumGrey"
  | "red"
  | "redDesktop"
  | "shadow"
  | "veryLightGrey"
  | "white"
  | "whiteSmoke";

const styleguideColors: { [key in IStyleGuideColorKey]: string } = {
  beige: "#FDF2DF",
  black: "#333333",
  brown: "#D4CBBC",
  darkBlack: "#252024",
  darkGold: "#aa976c",
  darkGrey: "#555555",
  darkRedDesktop: "#ba3629",
  gold: "#E1B76fE6",
  goldDesktop: "#aa976c",
  grey: "#9B9B9B",
  infoBackground: "#cce5ff",
  infoBorder: "#b8daff",
  infoText: "#004085",
  lightBrown: "#EEEBE1",
  lightGrey: "#EFEFEFEF",
  lightRed: "rgba(162, 28, 37, 0.7)",
  mediumGrey: "#DCDCDC",
  red: "#A21C25",
  redDesktop: "#d63432",
  shadow: "#33333380",
  veryLightGrey: "#CFCFCF",
  white: "#FFFFFF",
  whiteSmoke: "#f0f0f0",
};

export default {
  ...styleguideColors,
};
